import { SVGProps } from 'react';

const ArrowDownNarrowWide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m11 16-4 4-4-4m4 4V4m4 0h4m-4 4h7m-7 4h10"
    />
  </svg>
);
export default ArrowDownNarrowWide;
